import type { HookAPI } from 'antd/es/modal/useModal'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'

import Loader from '@/components/Atoms/Loader/Loader'
import { stockImportsApi } from '@/pages/Exchanges/tabs/StockImports/api/stockImportsApi'
import type {
  ProductSupplierDto,
  StoreModel,
} from '@/pages/Exchanges/tabs/StockImports/types/stockImports.types'

import SupplierCreationForm from './SupplierCreationForm'

interface Props {
  open: boolean
  supplier: ProductSupplierDto | null
  modal: HookAPI
  onClose: () => void
  onSaved: (supplier: ProductSupplierDto) => void
  onStoresChanged?: () => void
}

function SupplierCreationModal({ open, ...formProps }: Props) {
  const [stores, setStores] = useState<StoreModel[] | null>(null)

  useEffect(() => {
    if (!open) return

    let cancelled = false
    stockImportsApi
      .getStores()
      .then((storeList) => {
        if (!cancelled) setStores(storeList)
      })
      .catch(() => {
        if (cancelled) return
        toast.error('Не удалось загрузить список складов')
        setStores([])
      })

    return () => {
      cancelled = true
    }
  }, [open])

  if (stores === null)
    return open ? <Loader loaderType="modal" isModalOpen /> : null

  return <SupplierCreationForm open={open} stores={stores} {...formProps} />
}

export default SupplierCreationModal
